import { motion } from "framer-motion";
import { experiences } from "../../data/experiences";
import TimelineItem from "./TimelineItem";

export default function Timeline() {
  return (
    <section className="py-24 bg-terminal">
      <div className="max-w-4xl mx-auto px-6">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-3xl md:text-4xl font-bold text-center text-brightText mb-16"
        >
          Experience
        </motion.h2>

        <div className="relative">
          {/* Center line */}
          <div className="absolute left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-accentBlue via-neonBlue to-neonPurple transform -translate-x-1/2 hidden md:block shadow-[0_0_8px_rgba(125,211,252,0.3)]" />
          {/* Mobile line */}
          <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-gradient-to-b from-accentBlue via-neonBlue to-neonPurple md:hidden shadow-[0_0_8px_rgba(125,211,252,0.3)]" />

          <div className="flex flex-col gap-12">
            {experiences.map((exp, index) => (
              <TimelineItem key={exp.id} experience={exp} index={index} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
